export const uploadAvatarOptions = {
    accept: 'image/*',
    maxSize: 10485760,
    transformations: {force: true, circle: true, crop: false},
};
